export default 'Fonds chaleur ADEME : financement de la chaleur renouvelable et des réseaux de chaleur. Éligibilité, montage de dossier et cumuls avec primes CEE.';
